import { AGE_GROUPS, EVENT_STATUS } from "utils/helpers/enums/shared.enum";
import { FilterDTO } from "../shared/filter.dto";

export class ReviewFilterDTO extends FilterDTO {
    hostId: number;
    eventId?: number;


    constructor(data: Partial<ReviewFilterDTO> = {}) {
        super();
        for (let key in data) {
            this[key] = data[key];
        }
    }
}